import axios from 'axios'
import { getLakeHouseUrls } from "@/http/base.http";

export function ddLakeHouseSensor() {
    const { envLakeH } = getLakeHouseUrls();
    return axios.get(`${envLakeH}lakehouse/dd/sensor`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddLakeHouseDevice(payload) {
    const { envLakeH } = getLakeHouseUrls();
    return axios.post(`${envLakeH}lakehouse/dd/device`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddLakeHouseParameter() {
    const { envLakeH } = getLakeHouseUrls();
    return axios.get(`${envLakeH}lakehouse/dd/parameter`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function ddLakeHouseTime() {
    const { envLakeH } = getLakeHouseUrls();
    return axios.get(`${envLakeH}lakehouse/dd/time`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getLakeHouse(payload) {
    const { envLakeH } = getLakeHouseUrls();
    return axios.post(`${envLakeH}lakehouse/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}